/* eslint-disable jsx-a11y/alt-text */
import { Image, Text, View } from '@react-pdf/renderer';

import { getDifficultyDataForPdf } from '~/features/program/utils/get-difficulty-data';
import { useI18n } from '~/hooks/use-i18n';

import { createPdfStyles } from '../utils/create-pdf-styles';

import { styles as sharedStyles } from './syllabus-styles';

type SyllabusCourseOverviewProps = {
  title: string;
  overview: string;
  semanticType: string;
  level: string;
  displayDuration: string;
  reviewSummary?: {
    starsAverage: number;
    numberOfReviews: number;
  };
};

const styles = createPdfStyles({
  semanticTypeBox: {
    ...sharedStyles.pillContainer,
    backgroundColor: 'blue.500',
  },
  semanticTypeBoxText: {
    ...sharedStyles.text,
    color: '#fff',
  },
  badgesRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    gap: 24,
    marginTop: '16px',
    alignItems: 'center',
  },
  badge: {
    backgroundColor: '#EDF2F7',
    color: '#2D3748',
    borderRadius: 6,
    fontSize: '14px',
    fontWeight: 600,
    padding: '6px 16px',
    fontFamily: 'PolySans',
    textTransform: 'capitalize',
    letterSpacing: 1,
    marginRight: 8,
  },
  imageIcon: {
    width: '18px',
    height: '18px',
  },
  ratingText: {
    color: '#F2994A',
  },
  badgeContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 3,
  },
});

export function SyllabusCourseOverview(props: SyllabusCourseOverviewProps) {
  const { t } = useI18n();
  const { overview, semanticType, level, displayDuration, reviewSummary } = props;
  const difficultyData = level ? getDifficultyDataForPdf(t, level.toLowerCase()) : undefined;
  const displayReviews = reviewSummary && reviewSummary.numberOfReviews > 0;

  return (
    <View style={sharedStyles.section}>
      <Text style={sharedStyles.sectionTitle}>Overview</Text>
      <Text style={sharedStyles.text}>{overview}</Text>
      <View style={styles.badgesRow}>
        <View style={styles.semanticTypeBox}>
          <Text style={styles.semanticTypeBoxText}>{semanticType}</Text>
        </View>
        {difficultyData && (
          <View style={styles.badgeContainer}>
            <Image src={difficultyData.imageUrl} style={styles.imageIcon} />
            <Text style={sharedStyles.text}>{difficultyData.label}</Text>
          </View>
        )}
        {displayDuration && (
          <View style={styles.badgeContainer}>
            <Image src={'/images/time.png'} style={styles.imageIcon} />
            <Text style={sharedStyles.text}>{displayDuration}</Text>
          </View>
        )}
        {displayReviews && (
          <View style={styles.badgeContainer}>
            <Image src='/images/star_full.png' style={styles.imageIcon} />
            <Text style={[sharedStyles.text, styles.ratingText]}>{reviewSummary.starsAverage.toFixed(1)}</Text>
            <Text style={sharedStyles.text}>({reviewSummary.numberOfReviews} Reviews)</Text>
          </View>
        )}
      </View>
    </View>
  );
}
